import { Log, apiRequest } from '@ext/utils';
import { Paginacion } from '@ext/env';
export * from './ModificacionDeEstado.types';
import { IModificacionDeEstado } from './ModificacionDeEstado.lib';

export class ModificacionDeEstado extends IModificacionDeEstado {

    public static async find(pedido:number, params: any ): Promise<{ Paginacion: Paginacion, Items: Array<ModificacionDeEstado>; Error?: boolean; }> {

        let a: Array<ModificacionDeEstado> = [];
        let paginacion: Paginacion = new Paginacion();
        let request = new apiRequest( `/pedidos/${pedido}/estados` );
        request.params = params;
        request.params.sort ='DESC';
        request.params.order='fecha';
        if ( await request.get() ) {
            if ( request.data.response ) {
                paginacion = new Paginacion( request.data.response );
            }
            if ( request.data.results ) {
                for ( let i of request.data.results ) {
                    let p = new ModificacionDeEstado( i );
                    a.push( p );
                }

            }
        }
        return { Paginacion: paginacion, Items: a, Error: request.error };
    }

}